// import useRangeFilterDateColumn from './useRangeFilterDateColumn';
import { currencyFormat, dateFormat } from '../utils/formatter';
import useDateRangeCol from './useDateRangeCol';
import { resolveEnabledModules, isModuleEnabled } from '../config/permissions-registry';

const useInvoiceReactTableCols = (clientModules = null) => {
  // const invoiceDateCol = useRangeFilterDateColumn(
  //   'INVOICE_DTE', // TODO
  //   'INVOICE_DTE'
  // ); // TODO Invoice Date

  const invoiceDateCol = useDateRangeCol(
    'INVOICE_DTE', // TODO
    'Invoice Date'
  ); // TODO Invoice Date

  // Check if DOCUMENTS module is enabled for this client
  const enabledModules = clientModules ? resolveEnabledModules(clientModules) : null;
  const isDocumentsModuleEnabled = enabledModules ? isModuleEnabled('DOCUMENTS', enabledModules) : true; // Default to true if no clientModules provided (backward compatibility)

  const cols = [
    {
      accessorKey: 'COMPANY',
      header: 'Company',
      enableSorting: false,
      enableColumnFilter: true,
      size: 1,
    },
    {
      accessorKey: 'INVOICE',
      header: 'Invoice',
      enableSorting: false,
      enableColumnFilter: true,
      size: 1,
    },
    {
      accessorKey: 'INVOICE_TYPE',
      header: 'Type',
      enableSorting: false,
      enableColumnFilter: false,
      size: 1,
    },
    {
      accessorKey: 'VOUCHER_NBR',
      header: 'Voucher Number',
      enableSorting: false,
      enableColumnFilter: true,
      trimSearch: true,
      size: 1,
    },
    invoiceDateCol,
    // {
    //   accessorKey: 'INVOICE_DTE',
    //   header: 'Invoice Date',
    //   enableSorting: false,
    //   enableColumnFilter: false,
    //   size: 1,
    //   Cell: ({ cell }) => dateFormat(cell.getValue()),
    // },
    {
      accessorKey: 'BASE_INV_AMT',
      header: 'Amount',
      enableSorting: true,
      enableColumnFilter: false,
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: 'TRAN_INV_AMT',
      header: 'Trans Amount',
      enableSorting: true,
      enableColumnFilter: false,
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue()),
    },
    {
      accessorKey: 'DESCRIPTION',
      header: 'Description',
      enableSorting: false,
      enableColumnFilter: true,
      size: 1,
      innerSearch: true
    },
    {
      accessorKey: 'DUE_DATE',
      header: 'Due Date',
      enableSorting: true,
      enableColumnFilter: false,
      size: 1,
      Cell: ({ cell }) => dateFormat(cell.getValue()),
    },
    // {
    //   accessorKey: 'PO_NUMBER',
    //   header: 'Po',
    //   enableSorting: false,
    //   enableColumnFilter: true,
    //   size: 1
    // },
    {
      accessorKey: 'PO_LINK',
      header: 'Po',
      enableSorting: false,
      enableColumnFilter: false,
      size: 1,
    },
    {
      accessorKey: 'DISTRIBUTION',
      header: 'Distribution',
      enableSorting: false,
      enableColumnFilter: false,
      size: 1,
    },
    {
      accessorKey: 'PAYMENT',
      header: 'Payment',
      enableSorting: false,
      enableColumnFilter: false,
      size: 1,
    },
    {
      accessorKey: 'OPERATOR',
      header: 'Operator',
      enableSorting: false,
      enableColumnFilter: false,
      size: 1,
    },
    {
      accessorKey: 'COMMENT_VIEW',
      header: 'Comments',
      enableSorting: false,
      enableColumnFilter: false,
      size: 1,
    },
    {
      accessorKey: 'ATTACHMENT_VIEW',
      header: 'Attachment',
      enableSorting: false,
      enableColumnFilter: false,
      size: 1,
    },
    // Only include DOCUMENTS column if the DOCUMENTS module is enabled
    ...(isDocumentsModuleEnabled ? [{
      accessorKey: 'DOCUMENTS',
      header: 'Documents',
      enableSorting: false,
      enableColumnFilter: false,
      size: 1
    }] : [])
  ];

  return cols;
};



const usePoReactTableCols = () => {

  const poDateCol = useDateRangeCol(
    'PO_DATE', // TODO
    'Date'
  ); // TODO Invoice Date

  const cols = [
    {
      accessorKey: 'COMPANY',
      header: 'Company',
      enableSorting: false,
      enableColumnFilter: true,
      size: 1
    },
    {
      accessorKey: 'PO_NUMBER',
      header: 'PO Number',
      enableSorting: true,
      enableColumnFilter: true,
      trimSearch: true,
      Cell: ({ cell }) => {
        return <span>{cell.row.original.PO_LINK}</span>
      },
      size: 1
    },
    {
      accessorKey: 'PO_CODE',
      header: 'PO Code',
      enableSorting: false,
      enableColumnFilter: true,
      size: 1
    },
    poDateCol,
    // {
    //   accessorKey: 'PO_DATE',
    //   header: 'Date',
    //   enableSorting: false,
    //   enableColumnFilter: false,
    //   size: 1,
    //   Cell: ({ cell }) => dateFormat(cell.getValue()),
    // },
    {
      accessorKey: 'BUYER_CODE',
      header: 'Buyer',
      enableSorting: false,
      enableColumnFilter: true,
      size: 1
    },
    {
      accessorKey: 'TOT_PRD_AMT',
      header: 'Amount',
      enableSorting: true,
      enableColumnFilter: false,
      size: 1,
      Cell: ({ cell }) => currencyFormat(cell.getValue())
    },
    {
      accessorKey: 'NBR_LINES',
      header: 'Line Count',
      enableSorting: true,
      enableColumnFilter: false,
      size: 1
    },
    // {
    //   accessorKey: 'view',
    //   header: 'Payment',
    //   enableSorting: false,
    //   enableColumnFilter: false,
    //   size: 1
    // }
  ]

  return cols;
};


const useLocationReactTableCols = () => {

  const LocDateCol = useDateRangeCol(
    'EFFECTIVE_DATE', // TODO
    'Date'
  ); // TODO Invoice Date

  const cols = [
    {
      accessorKey: 'LOCATION_CODE',
      header: 'Location Code',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'LOC_TYPE',
      header: 'Type',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'ACTIVE_STATUS',
      header: 'Status',
      filterFn: 'contains',
      size: 1
    },
    LocDateCol,
    {
      accessorKey: 'ADDR1',
      header: 'Address 1',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'ADDR2',
      header: 'Address 2',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'ADDR3',
      header: 'Address 3',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'ADDR4',
      header: 'Address 4',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'CITY_ADDR5',
      header: 'City',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'STATE_PROV',
      header: 'State',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'POSTAL_CODE',
      header: 'Zip',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'COUNTY',
      header: 'County',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'COUNTRY',
      header: 'Country',
      filterFn: 'contains',
      size: 1
    },
    {
      accessorKey: 'CUR_ADDR',
      header: 'Current',
      filterFn: 'contains',
      size: 1
    }
  ]

  return cols;
};



const useInvoiceMatchingTableCols = () => {

  const cols = [
  {
    accessorKey: 'LINE_NBR',
    header: 'Line',
    enableSorting: false,
    enableColumnFilter: false,
    size:1
  },
  {
    accessorKey: 'ITEM',
    header: 'Item',
    enableSorting: false,
    enableColumnFilter: false,
    size:1
  },
  {
    accessorKey: 'ITEM_DESC',
    header: 'Desc',
    enableSorting: false,
    enableColumnFilter: false,
    size:1
  },
  {
    accessorKey: 'ENTERED_QTY',
    header: 'Qty',
    enableSorting: false,
    enableColumnFilter: false,
    size:1,
    Cell: ({ cell }) => {
      return <span>{cell.row.original.MATCH_LINK}</span>
    }
  },
  {
    accessorKey: 'ENT_UOM',
    header: 'UOM',
    enableSorting: false,
    enableColumnFilter: false,
    size:1
  },
  {
    accessorKey: 'ENT_UNIT_CST',
    header: 'Unit Cost',
    enableSorting: false,
    enableColumnFilter: false,
    size:1
  },
  {
    accessorKey: 'TOT_BASE_AMT',
    header: 'Amount',
    enableSorting: false,
    enableColumnFilter: false,
    size:1
  },
  {
    accessorKey: 'MATCHED_QTY',
    header: 'Match Qty',
    enableSorting: false,
    enableColumnFilter: false,
    size:1
  }
]
  return cols;
};


const useInvoiceMatchReactTableCols = () => {
const cols = [
{
accessorKey: 'DOC',
header: 'Doc',
enableSorting: false,
enableColumnFilter: false,
size:1
},
    {
      accessorKey: 'DESCRIPTION',
      header: 'Description',
      enableSorting: false,
      enableColumnFilter: false,
      size:1
      },
    {
      accessorKey: 'DOC_NUMBER',
      header: 'Doc Number',
      enableSorting: false,
      enableColumnFilter: false,
      size:1
      },
    {
      accessorKey: 'STATUS',
      header: 'Status',
      enableSorting: false,
      enableColumnFilter: false,
      size:1
      },
    {
      accessorKey: 'ORIG_REC_QTY',
      header: 'Orig Rec Qty',
      enableSorting: false,
      enableColumnFilter: false,
      size:1
      },
    {
      accessorKey: 'MATCHED_QTY',
      header: 'Matched Qty',
      enableSorting: false,
      enableColumnFilter: false,
      size:1
      },
    {
      accessorKey: 'QTY_TO_MATCH',
      header: 'Qty To Match',
      enableSorting: false,
      enableColumnFilter: false,
      size:1
      },
    {
      accessorKey: 'ENT_REC_UOM',
      header: 'Ent Rec Uom',
      enableSorting: false,
      enableColumnFilter: false,
      size:1
      },
    {
      accessorKey: 'ORIG_UNIT_CST',
      header: 'Orig Unit Cst',
      enableSorting: false,
      enableColumnFilter: false,
      size:1,
      Cell: ({ cell }) => currencyFormat(cell.getValue())
      },
    {
      accessorKey: 'MATCH_UNIT_CST',
      header: 'Match Unit Cst',
      enableSorting: false,
      enableColumnFilter: false,
      size:1,
      Cell: ({ cell }) => currencyFormat(cell.getValue())
      },
      {
        accessorKey: 'EXTENDED_AMT',
        header: 'Extended Amt',
        enableSorting: false,
        enableColumnFilter: false,
        size:1,
        Cell: ({ cell }) => currencyFormat(cell.getValue())
        }
      ]
return cols
    }


const useVendorAgreementLinesCols = () => {
  const cols = [
    {
      accessorKey: 'LINE_NBR',
      header: 'Line'
    },
    {
      accessorKey: 'VEN_ITEM',
      header: 'Vendor Item'
    },
    {
      accessorKey: 'ITEM_DESC',
      header: 'Item',
      Cell: ({ cell }) => {
        return <span>{cell.row.original.ITEM_LINK}</span>;
      },
    },
    {
      accessorKey: 'BASE_COST',
      header: 'Base Cost',
      Cell: ({ cell }) => currencyFormat(cell.getValue())

    },
    {
      accessorKey: 'UOM',
      header: 'UOM'
    },
    {
      accessorKey: 'COST_OPTION',
      header: 'Cost Option'
    },
    {
      accessorKey: 'DESCRIPTION',
      header: 'Description'
    },
    {
      accessorKey: 'DIST_COMPANY',
      header: 'Dist Company'
    },
    {
      accessorKey: 'ACCT_UNIT',
      header: 'Acct Unit'
    },
    {
      accessorKey: 'ACCOUNT',
      header: 'Account'
    },
    {
      accessorKey: 'SUB_ACCOUNT',
      header: 'Sub Account'
    },
    {
      accessorKey: 'ACTIVITY',
      header: 'Activity'
    },
    {
      accessorKey: 'ACCT_CATEGORY',
      header: 'Acct Category'
    },
    {
      accessorKey: 'AC_COMMIT_FLAG',
      header: 'Ac Commit Flag'
    },
    {
      accessorKey: 'GL_COMMIT_FLAG',
      header: 'Gl Commit Flag'
    },
    {
      accessorKey: 'BILLING_CATEGORY',
      header: 'Billing Category'
    },
    {
      accessorKey: 'GTIN',
      header: 'Gtin'
    },
    {
      accessorKey: 'REQ_COMPANY',
      header: 'Req Company'
    },
    {
      accessorKey: 'REQ_LOCATION',
      header: 'Req Location'
    },
    {
      accessorKey: 'HOLD_REASON',
      header: 'Hold Reason'
    },
    {
      accessorKey: 'COMMENT_VIEW',
      header: 'Comments'
    }
  ];

  return cols;
};


const useVendorAgreementServiceLinesCols = () => {

  const cols = [
    {
      accessorKey: 'LINE_NBR',
      header: 'Line'
    },
    {
      accessorKey: 'DESCRIPTION',
      header: 'Description'
    },
    {
      accessorKey: 'SERVICE_CODE',
      header: 'Service Code'
    },
    {
      accessorKey: 'BASE_COST',
      header: 'Base Cost',
      Cell: ({ cell }) => currencyFormat(cell.getValue())
    },
    {
      accessorKey: 'UOM',
      header: 'UOM'
    },
    {
      accessorKey: 'TAX_CODE',
      header: 'Tax Code'
    },
    {
      accessorKey: 'TAX_USAGE_CD',
      header: 'Tax Usage'
    },
    {
      accessorKey: 'AGRMT_MAX_QTY',
      header: 'Agmt Max Qty'
    },
    {
      accessorKey: 'ORDER_MAX_QTY',
      header: 'Inv Max Qty'
    },
    {
      accessorKey: 'ORDER_MIN_QTY',
      header: 'Inv Min Qty'
    },
    {
      accessorKey: 'AGRMT_MAX_AMT',
      header: 'Agmt Max Amt',
      Cell: ({ cell }) => currencyFormat(cell.getValue())
    },
    {
      accessorKey: 'ORDER_MAX_AMT',
      header: 'Inv Max Amt'
    },
    {
      accessorKey: 'ORDER_MIN_AMT',
      header: 'Inv Min Amt',
      Cell: ({ cell }) => currencyFormat(cell.getValue())
    },
    {
      accessorKey: 'CONTRACT_GROUP',
      header: 'Contract Group'
    },
    { 
      accessorKey: 'CM_CONTRACT',
      header: 'Contract'
    },
    {
      accessorKey: 'DIST_COMPANY',
      header: 'Dist Company'
    },
    { 
      accessorKey: 'ACCT_UNIT',
      header: 'Acct Unit'
    },
    {
      accessorKey: 'ACCOUNT',
      header: 'Account'
    },
    {
      accessorKey: 'SUB_ACCT',
      header: 'Sub Account'
    },
    {
      accessorKey: 'ACTIVITY',
      header: 'Activity'
    },
    {
      accessorKey: 'ACCT_CATEGORY',
      header: 'Acct Category'
    },
    {
      accessorKey: 'BILLING_CATEGORY',
      header: 'Billing Category'
    },
    {
      accessorKey: 'AC_COMMIT_FLAG',
      header: 'AC Commitments'
    },
    {
      accessorKey: 'GL_COMMIT_FLAG',
      header: 'GL Commitments'
    },
    {
      accessorKey: 'REASON_CODE',
      header: 'Hold Reason'
    },
    {
      accessorKey: 'COMMODITY_CODE',
      header: 'Commodity Code'
    },
    {
      accessorKey: 'COMMENT_VIEW',
      header: 'Comments'
    }
  ];

  return cols;
};

const useVendorAgreementsTableCols = () => {

  const effectiveDateCol = useDateRangeCol(
    'EFFECTIVE_DT', // TODO
    'Effective Date'
  ); 
  const expireDateCol = useDateRangeCol(
    'EXPIRE_DT', // TODO
    'Expire Date'
  ); 
  const reviewDateCol = useDateRangeCol(
    'REVIEW_DATE', // TODO
    'Review Date'
  ); 

  const cols = [
    {
      accessorKey: 'PROCURE_GROUP',
      header: 'Procure Group'
    },
    {
      accessorKey: 'VEN_AGRMT_REF',
      header: 'Ven Agreement Ref',
      size: 1,
      Cell: ({ cell }) => {
        return <span>{cell.row.original.AGREEMENT_LINK}</span>;
      },
    },
    {
      accessorKey: 'AGMT_TYPE',
      header: 'Agreement Type '
    },
    {
      accessorKey: 'VENDOR',
      header: 'Vendor'
    },
    {
      accessorKey: 'PO_NUMBER',
      header: 'Po Number',
      size: 1
    },
    {
      accessorKey: 'PURCH_FR_LOC',
      header: 'Purch From Loc',
      size: 1
    },
    {
      accessorKey: 'DESCRIPTION',
      header: 'Description',
      innerSearch: true
    },
    effectiveDateCol,
    expireDateCol,
    reviewDateCol
  ];

  return cols;
};

const useVendorAgreementParticipantsCols = () => {
  const cols = [
    {
      accessorKey: 'COMPANY',
      header: 'Company'
    },
    {
      accessorKey: 'LOCATION',
      header: 'Location'
    },
    {
      accessorKey: 'REQ_LOC',
      header: 'Requesting Location'
    },
    {
      accessorKey: 'ACCT_UNIT',
      header: 'Account Unit'
    }
  ];
  return cols;
};

export { 
  useInvoiceReactTableCols,
  usePoReactTableCols,
  useLocationReactTableCols,
  useInvoiceMatchingTableCols,
  useInvoiceMatchReactTableCols,
  useVendorAgreementLinesCols,
  useVendorAgreementServiceLinesCols,
  useVendorAgreementsTableCols,
  useVendorAgreementParticipantsCols
 };
